export function progressIdFactory(
  progressGuid: string,
  registrationId: string
) {
  return `${progressGuid}_${registrationId}`;
}
